import { render, staticRenderFns } from "./nice-option.vue?vue&type=template&id=65cdaefa&scoped=true"
import script from "./nice-option.vue?vue&type=script&lang=js"
export * from "./nice-option.vue?vue&type=script&lang=js"
import style0 from "./nice-option.vue?vue&type=style&index=0&id=65cdaefa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdaefa",
  null
  
)

export default component.exports